export const couponUnits = {
    PERCENT: '%',
    CASH: '₪',
    MONTHS: 'Ⓜ'
}

export const couponStatus = {
    ACTIVE: 'פעיל',
    HOLD: 'בהקפאה',
    DISABLED: 'מבוטל',
    USED: 'בשימוש'
}
